export const defaultMobileColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262"
};
export const defaultDesktopColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262"
};
